"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentShareView = void 0;
var _react = require("react");
var _main = require("../../../main");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
var EnvironmentShareView = function EnvironmentShareView(props) {
  var _productInfo$shareMes, _productInfo$ProductU;
  var environmentTitle = props.environmentTitle,
    productInfo = props.productInfo,
    onClose = props.onClose;
  var _useContext = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext),
    getLabel = _useContext.getLabel,
    setSliderView = _useContext.setSliderView;
  var defaultShareURL = 'https://myofek.cet.ac.il';
  var defaultShareMessageText = getLabel('share_env').replace('{X}', "\"".concat(productInfo.ProductName, "\"")).replace('{Y}', "\"".concat(environmentTitle, "\""));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "environmentShareView",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.SocialShare, {
      layout: "inline",
      shareList: ['link', 'whatsapp', 'teams', 'googleClassroom'],
      title: environmentTitle,
      whatsappText: (_productInfo$shareMes = productInfo.shareMessageLineText) !== null && _productInfo$shareMes !== void 0 ? _productInfo$shareMes : defaultShareMessageText,
      onBack: function onBack() {
        setSliderView('environmentSaved');
      },
      onClose: onClose,
      url: (_productInfo$ProductU = productInfo.ProductURL) !== null && _productInfo$ProductU !== void 0 ? _productInfo$ProductU : defaultShareURL
    })
  });
};
exports.EnvironmentShareView = EnvironmentShareView;